import queryString from 'query-string';
import Cookie from 'js-cookie';

export default {
  save(search) {
    const { partner } = queryString.parse(search);

    if (!partner) {
      return;
    }

    if (Cookie.get('affiliate_id')) {
      return;
    }

    Cookie.set('affiliate_id', String(partner), {
      expires: 180,
    });
  },

  get() {
    return Cookie.get('affiliate_id') || '0';
  },
};
